import { isRef } from 'vue';

/**
 * Build query string from object, without prefixing the string with '?'.
 *
 * @param params Object to be converted, may contain simple values and arrays.
 * If a value is a Ref object, the value of the Ref object is used.
 * Undefined values are ignored.
 */
export function buildQuery(params: object | undefined): string {
  if (!params) {
    return '';
  }
  const query: string[] = [];
  Object.entries(params).forEach(([key, value]: [string, any]) => {
    if (Array.isArray(value)) {
      value.forEach((item) => {
        query.push(`${key}=${encodeURIComponent(item)}`);
      });
    } else {
      if (isRef(value)) {
        value = value.value;
      }
      if (value || value === 0) {
        query.push(`${key}=${encodeURIComponent(value)}`);
      }
    }
  });
  return query.join('&');
}

export function isStorybookUrlPath(path: string): boolean {
  return path == '/storybook' || path.startsWith('/storybook/') || path == '/sb' || path.startsWith('/sb/');
}
